import templateMainCars from './templates/carsForm.tmpl.html';
import templateMainCarsResultsMain from './templates/car-results.html';
import templateMainCarsResultsPageHeader from './templates/results_title.tmpl.html';
import templateMainCarsResultsFilter from './templates/car-filters.html';
import templateMainCarsResultsMap from './templates/car-results-map.html';
import templateMainCarsResultsCarousel from './templates/car-carousel.html';
import templateMainCarsResultsCars from './templates/car-result-list.html';
import templateMainCarsRules from './templates/rules.tmpl.html';
import CarsSearchFormController from './controllers/cars-search-form-controller';
import CarsRulesController from './controllers/carsRulesCtrl';
import CarsFiltersController from './controllers/carsFiltersCtrl';
import CarsMapController from './controllers/cars-map-controller';
import CarsCarouselController from './controllers/carsCarouselCtrl';
import CarsListController from './controllers/carsListCtrl';

import CarsHeaderController from './controllers/carsHeaderCtrl';

export const carStates = {
    MAIN: 'main.cars',
    RESULTS: 'main.cars.results',
    RULES: 'main.cars.rules',
};

export default function CarsRoutes($stateProvider) {
    'ngInject';

    $stateProvider
        .state(carStates.MAIN, {
            url: '/cars',
            views: {
                '': {
                    template: templateMainCars,
                    controller: CarsSearchFormController,
                },
            },
            onEnter: ($rootScope) => {
                'ngInject';
                $rootScope.pageHeading = 'Cars search';
            },
        })
        .state(carStates.RESULTS, {
            url: '/results?' + [
                'Radius',
                'IsUserAgeOutOfRange',
                'PickUpLatitude',
                'PickUpLongitude',
                'IsPickupLocationAirport',
                'PickUpAddress',
                'DropOffLatitude',
                'DropOffLongitude',
                'IsDropOffLocationAirport',
                'DropOffAddress',
                '{PickUpDate:customDate}',
                '{DropOffDate:customDate}',
                'Min',
                'Max',
                'CarSorting',
            ].join('&'),
            onExit: ($rootScope) => {
                'ngInject';
                $rootScope.pageHeading = 'Cars search';
            },
            resolve: {
                searchData: (carsFactory, $stateParams) => {
                    'ngInject';
                    return carsFactory.getSearchData($stateParams);
                },
            },
            views: {
                '@main': {
                    template: templateMainCarsResultsMain,
                    controller: ($scope, searchData) => {
                        'ngInject';
                        $scope.haveResults = !!searchData.searchResults.total;
                    },
                },
                [`pageHeader@${carStates.RESULTS}`]: {
                    template: templateMainCarsResultsPageHeader,
                    controller: CarsHeaderController,
                    controllerAs: 'carsHeaderCtrl',
                },
                [`resultsFilters@${carStates.RESULTS}`]: {
                    template: templateMainCarsResultsFilter,
                    controller: CarsFiltersController,
                },
                [`resultsMap@${carStates.RESULTS}`]: {
                    template: templateMainCarsResultsMap,
                    controller: CarsMapController,
                },
                [`resultsCarousel@${carStates.RESULTS}`]: {
                    template: templateMainCarsResultsCarousel,
                    controller: CarsCarouselController,
                    controllerAs: '$ctrl',
                },
                [`resultsCars@${carStates.RESULTS}`]: {
                    template: templateMainCarsResultsCars,
                    controller: CarsListController,
                    controllerAs: '$ctrl',
                },
            },
        })

        .state(carStates.RULES, {
            url: '/rules?' + [
                'carId',
                'searchId',
                'userRestriction',
                'culture',
                'CarFareId',
            ].join('&'),
            resolve: {
                rules: ($http, $stateParams, sessionService, appCONST, loginFactory, l10nService) => {
                    'ngInject';
                    const isReadOnlyMode = sessionService.getSessionItem('readOnlyMode');

                    const rulesURL = (isReadOnlyMode)
                        ? '/cars/GetRulesAnonymous'
                        : '/cars/GetRules';

                    return $http.apiGET(rulesURL, {params: $stateParams})
                        .then(({data}) => {
                            data.isSurcharge = ($stateParams.userRestriction === 'true');
                            if (!isReadOnlyMode) {
                                return data;
                            }
                            return loginFactory.getLocalization($stateParams.culture)
                                .then((localizationResponse) => {
                                    l10nService.updateList(localizationResponse);
                                    return data;
                                });
                        });
                },

            },
            views: {
                '@main': {
                    template: templateMainCarsRules,
                    controller: CarsRulesController,
                },
            },
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/cars-routes.js